import ReactPaginate from "react-paginate";
import { KTIcon } from "../../../../../_metronic/helpers";
import React from "react";
import { number } from "yup";

export default function Pagination({
  activePage,
  setQueryString,
  totalRows,
  numberInPage = 10,
}: {
  activePage: number;
  setQueryString: any;
  totalRows: number;
  numberInPage?: number | string;
}) {
  //* will get active page setActive page from index
  // const [pageArr,setPageArr] = React.useState([5,4,3,2,1])
  return (
    <div className={"d-flex gap-3 align-items-center"}>
      <div>
        <span className="text-gray">تعداد رکورد در هر صفحه:</span>
        <span>{numberInPage}</span>
      </div>
      <div>
        <span className="text-gray"> تعداد کل:</span>
        <span>{totalRows}</span>
      </div>
      <div style={{ marginRight: "auto" }}>
        <PaginatedItems
          setQueryString={setQueryString}
          totalRows={totalRows}
          activePage={activePage}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
}

function PaginatedItems({
  setQueryString,
  totalRows,
  activePage,
  numberInPage,
}: {
  setQueryString: any;
  totalRows: number;
  activePage: number;
  numberInPage: number | string;
}) {
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  // const [itemOffset, setItemOffset] = React.useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const itemsPerPage = Number(numberInPage);
  // const endOffset = itemOffset + itemsPerPage;
  // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  // const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(totalRows / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageChange = (event) => {
    // const newOffset = (event.selected * itemsPerPage) % totalRows;
    // console.log(
    //   `User requested page number ${event.selected}, which is offset ${newOffset}`,
    // );
    // event.preventDefault()
    // setItemOffset(newOffset);
    // event.preventDefault()
    setQueryString(Math.max(event.selected) + 1);
  };

  return (
    <div style={{ direction: "ltr" }}>
      {/*<Items currentItems={currentItems} />*/}
      <ReactPaginate
        previousLabel={
          <KTIcon iconName={"left"} className={"fs-3 text-primary"} />
        }
        nextLabel={
          <KTIcon iconName={"right"} className={"fs-3 text-primary"} />
        }
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={pageCount}
        // marginPagesDisplayed={2}
        pageRangeDisplayed={Number(numberInPage)}
        onPageChange={handlePageChange}
        containerClassName="pagination"
        activeClassName="active"
        forcePage={activePage - 1}
      />
    </div>
  );
}
